import { Close, Edit, Email, Phone } from "@mui/icons-material";
import { Avatar, Box, Button, Dialog, IconButton, Skeleton, Typography } from "@mui/material";
import theme from "../../theme/theme";
import getInitials from "../../utils/getInitails";
export const ViewEmployeeDialog = ({ openViewDialog, setOpenViewDialog, viewLoading, employee,editEmployee }) => {
    return (
        <Dialog
            open={openViewDialog}
            onClose={() => setOpenViewDialog(false)}
            PaperProps={{
                sx: {
                    borderRadius: theme.dialog.borderRadius,
                    minWidth: theme.dialog.minWidth
                }
            }}
        >

            <Box sx={{ backgroundColor: theme.dialog.headerBgColor, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                    <Typography variant="h6" fontWeight={'bold'} color={theme.palette.primary.main}>
                        Employee Details
                    </Typography>
                </Box>
                <Box>
                    <IconButton onClick={() => setOpenViewDialog(false)}>
                        <Close />
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        {viewLoading ? (
                            <Skeleton variant="circular" width={theme.dialog.avatar.width} height={theme.dialog.avatar.height} />
                        ) : (
                            <Avatar sx={{ width: theme.dialog.avatar.width, height: theme.dialog.avatar.height }}>{getInitials(employee.name)}</Avatar>
                        )}
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                        {viewLoading ? (
                            <>
                                <Skeleton variant="text" width={150} height={32} sx={{ mx: 'auto' }} />
                                <Skeleton variant="text" width={100} height={20} sx={{ mx: 'auto' }} />
                            </>
                        ) : (
                            <>
                                <Typography variant="h6">{employee.name || 'N/A'}</Typography>
                                <Typography variant="body2" textAlign={'center'} color="textSecondary">ID: {employee.employee_id || 'N/A'}</Typography>
                                <Typography variant="body2" textAlign={'center'} color={theme.palette.primary.main}>{employee.designation || 'N/A'}</Typography>
                            </>
                        )}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginTop: 2 }}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Box sx={{ p: 2, backgroundColor: '#e0f7fa', borderRadius: '50%' }}>
                            <Phone color={theme.palette.primary.main} />
                        </Box>
                        <Box>
                            <Typography variant="body1">Phone: </Typography>
                            {viewLoading ? (
                                <Skeleton variant="text" width={120} height={24} />
                            ) : (
                                <Typography variant="body1">{employee.phone || 'N/A'}</Typography>
                            )}
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Box sx={{ p: 2, backgroundColor: '#e0f7fa', borderRadius: '50%' }}>
                            <Email color={theme.palette.primary.main} />
                        </Box>
                        <Box>
                            <Typography variant="body1">Email: </Typography>
                            {viewLoading ? (
                                <Skeleton variant="text" width={180} height={24} />
                            ) : (
                                <Typography variant="body1">{employee.email || 'N/A'}</Typography>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ backgroundColor: theme.dialog.headerBgColor, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button variant="contained" onClick={() => setOpenViewDialog(false)} sx={{ backgroundColor: theme.button.backgroundColor, color: '#000', borderRadius: theme.button.borderRadius }}>
                    Close
                </Button>
                <Button variant="contained" onClick={() => editEmployee(employee.id)} sx={{ backgroundColor: theme.button.editBackgroundColor, borderRadius: theme.button.borderRadius }} startIcon={<Edit />}>
                    Edit Employee
                </Button>
            </Box>
        </Dialog>
    );
}